import { schAloftPrice } from '@aloft/toolkit-shared';
import { z } from 'zod';

export const schReconciliationForm = z.object({
  totalCostToCure: schAloftPrice.optional(),
  opinionOfMarketValue: schAloftPrice.optional(),
  reconciliationCommentary: z.string().optional(),
  highestAndBestUseCommentary: z.string().optional(),
  revisionCommentary: z.string().optional(),
  alternativeComparablesCommentary: z.array(z.string()).optional(),
});
export type ReconciliationFormOutput = z.infer<typeof schReconciliationForm>;
export type ReconciliationForm = typeof schReconciliationForm;
